import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import language from '../../../../assets/languages/language';
import SoaP_SubscriptionCheck from '../../../RestAPI/SoaPSubscription';
import PartnerSoaP_SubscriptionCheck from '../../../RestAPI/PartnerSubscription/SoaPSubscription';
import ModalComponent from '../../../Common/Modal';
import AlertMessage from '../../../config/alertMessage';
// import Axios from 'axios';
// import { saveAs } from 'file-saver';
import { examNameAccordingToDB } from '../../../../common/constant';
import { messages } from '../../../../common/messages';
import {autorun} from "mobx";
import userStore from "../../../../store/userStore";
/* eslint-disable*/

class SOA_P_Notes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: App_data.messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_soa_p,
      chapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      showFreePremium: '',
      selectedmenu: 'soa_p',
      pdfLoading: true,
      lastRecord: '',
      lastAttempt: false,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    //this._getReadings = this._getReadings.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  _getReadings = (chapter, e) => {
    // console.log(chapter);
    if (chapter.chapter_no === 1) {
      this.context.router.push({
        pathname: `/soa/probability/notesreadings/${chapter.chapter_no}`,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: chapter.chapter_no,
        },
      });
    } else {
      var final_exam = [];
      var data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
        // console.log("resp", resp);

        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;

            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaPNotesSubscription(
                    selectedmen,
                    exam_data,
                  );
                  if (isInArray_var) {
                    this.context.router.push({
                      pathname: `/soa/probability/notesreadings/${chapter.chapter_no}`,
                      state: {
                        token: this.state.token,
                        idname: this.state.idname,
                        chapter: chapter.chapter_no,
                      },
                    });
                  } else {
                    this.toggleAlert();
                  }
                } else {
                  // console.log('fail');
                }
              },
            );
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            this.toggleAlert();
          } else {
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              resp_exam => {
                // console.log(resp_exam);
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  // console.log(exam_data);
                  // console.log(selectedmen);
                  isInArray_var = SoaP_SubscriptionCheck.checkSoaPNotesSubscription(
                    selectedmen,
                    exam_data,
                  );
                  // console.log(isInArray_var);
                  if (isInArray_var) {
                    this.context.router.push({
                      pathname: `/soa/probability/notesreadings/${chapter.chapter_no}`,
                      state: {
                        token: this.state.token,
                        idname: this.state.idname,
                        chapter: chapter.chapter_no,
                      },
                    });
                  } else {
                    this.toggleAlert();
                  }
                } else {
                  // console.log('fail');
                }
              },
            );
          }
        }
      });
    }
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    if (localStorage.getItem('selectedmenu') === 'frm') {
      this.context.router.push({
        pathname: '/frm/questionbank/',
        state: {
          token: storage_session['token'],
          idname: storage_session['idname'],
        },
      });
    }

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(App_data.backend_api + '/soa_p_notes/getChapters', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, chapters: resp.chapters });
        var data = { token: this.state.token, idname: this.state.idname };
        FD.callAPI(App_data.backend_api + '/soa_p_notes/getlastReadNotes', data).then(response => {
          if (response.success) {
            this.setState({
              lastRecord: response.data,
              lastAttempt: true,
            });
          }
        });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
    var final_exam = [];
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
    this.dispose = autorun(() => {
      const resp = userStore;
      if(resp == null || resp.profileInfo == null){
        return;
      }
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaPNotesSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({ showFreePremium: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          // console.log("dsarafaygdu", data_arr);

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                // console.log(exam_data);
                // console.log(selectedmen);
                isInArray_var = SoaP_SubscriptionCheck.checkSoaPNotesSubscription(
                  selectedmen,
                  exam_data,
                );
                // console.log(isInArray_var);
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  }

  goToNotes = async () => {
    const { lastRecord, lastAttempt } = this.state;
    if (lastAttempt) {
      this.context.router.push({
        pathname:
          '/soa/probability/beginnotes/' +
          lastRecord.soa_p_note.chapter_id +
          '/' +
          lastRecord.soa_p_note.reading_id +
          '/' +
          lastRecord.soa_p_note.id +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          reading: lastRecord.soa_p_note.reading_id,
          chapter: lastRecord.soa_p_note.chapter_id,
          offset: 0,
        },
      });
    }
  };

  componentWillUnmount() {
    if(this.dispose) this.dispose();
  }

  render() {
    let chapters = this.state.chapters;
    let data = '';
    const { lastAttempt } = this.state;
    if (this.state.chapters.length) {
      data = chapters.map(item => (
        <div className='col-md-6 col-lg-6 col-xl-4 question_box free-premium-section' key={item.id}>
          <div
            className='question_bank_wrap pointer_class'
            key={item.id}
            onClick={this._getReadings.bind(this, item)}
          >
            {this.state.showFreePremium ? (
              item.id === 1 ? (
                <div className='tag-tile free'> {language.LC().FREE} </div>
              ) : (
                <div className='tag-tile premium'> {language.LC().PREMIUM} </div>
              )
            ) : null}

            <div className='margin_bottom_30'>
              <img
                src={App_data.frontend_url + '/img/notes/notes_icon1.svg'}
                className=''
                width='40'
                alt=''
              />
            </div>

            <div className='question_title' key={item.id} value={item.id}>
              <a>
                {/* <a className="pointer_class" id={item.chapter_name} value={item.chapter_no} onClick={this._getReadings.bind(this, item)}>*/}
                {item.chapter_no} {item.chapter_name}
                {/*</a>*/}
              </a>
            </div>

            <ul key={item.chapter_name}>
              <li>
                <span>
                  <img
                    src={App_data.frontend_url + '/img/notes/notes_icon2.svg'}
                    className=''
                    width='24'
                    alt=''
                  />
                </span>
                <span>
                  {/*Total Readings:*/} {item.Countreading}
                </span>
                <div className='tootip_box'>{language.LC().TOTAL_READINGS}</div>
              </li>

              <li>
                <span>
                  <img
                    src={App_data.frontend_url + '/img/notes/notes_icon3.svg'}
                    className=''
                    width='20'
                    alt=''
                  />
                </span>
                <span>
                  {/*Total Learning Objectives: */}
                  {item.Countquestion}
                </span>
                <div className='tootip_box'>{language.LC().TOTAL_NOTES}</div>
              </li>
            </ul>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='margin_bottom_20 d-flex justify-content-between'>
          <h1 className='section_head'>{language.LC().NOTES}</h1>
          {lastAttempt && (
            <button
              className='btn btn-primary pointer_class'
              onClick={this.goToNotes}
              disabled={!lastAttempt}
            >
              {messages.GO_TO_MY_LAST_READ_NOTE}
            </button>
          )}
        </div>
        <div className='row'>
          <div className='col-12 seperator-block-wrap'>
            <div className='card'>
              <div className='card-block'>
                <div className='card-block'>
                  <div className='row'>{data}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
          exam={examNameAccordingToDB.SOA_P}
        />
      </div>
    );
  }
}

export default SOA_P_Notes;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/Notes/Notes.js